import React from 'react';
import BasePage, { IBasePageProps } from '@/pages/BasePage';
import Layout from '@/components/Layout';
import Icon, { IconType } from '@/components/Icon';
import { getAppTheme, setScreenColor, getIntl } from '@/components/App/App';
import { getI18nText, handleStoreServiceTypesScroll } from '@/utils/app';
import paths from '@/routes/paths';
import { prefix } from '.';
import Config from '@/Config';

interface IBrandListPageProps extends IBasePageProps {}

interface IBrandListPageState {}

class LocationListPage extends BasePage<IBrandListPageProps, IBrandListPageState> {
  constructor(props: IBrandListPageProps) {
    super(props);

    this.state = {}
  }
  componentDidMount() {
    const appTheme = getAppTheme();
    if (appTheme.darkBackgroundColor && appTheme.primaryColor) {
      setScreenColor(appTheme.primaryColor, appTheme.darkBackgroundColor);
    }

    super.componentDidMount();
    this.autoCloseLoading = false;
  }

  handleGoBackMember = () => {
    this.handleGoBack({
      path: paths.HOME,
      runGoBack: true,
    });
  }

  handleClick = (type: string, fromPage: string) => {
    handleStoreServiceTypesScroll(type);
    this.handleGotoRoute({
      path: paths.STORE_LIST_BY_LOCATION,
      pathParams: {
        locationID: type,
        fromPage: fromPage,
      },
    });
  }

  render () {
    const { reducersState } = this.props;
    const { language, platformStoreLocations } = reducersState.app;
    return(
      <Layout
        {...this.props}
        className={prefix}
        navBar={
          <div className="bm-navbar-fixed">
            <div className="navbar-top">
              <div className="navbar-left" onClick={this.handleGoBackMember}>
                <Icon className="back-icon" type={IconType.LEFT_OUTLINED} />
              </div>
              <div className="navbar-title">{getIntl().page.location}</div>
              <div className="navbar-right"></div>
            </div>
          </div>
        }
      >
        <div className="brands-all">
          <div className="brands-all-rectangle"></div>
          <span className="brands-all-title">{getIntl().page.allLocation}</span>
        </div>
        <div className="brands">
          {
            platformStoreLocations.map(item => (
              <div className="brands-item" key={item.id} onClick={() => this.handleClick(item.id, 'location')}>
                <div className="brands-item-img" style={{backgroundImage: `url(${item.locationImage ? item.locationImage : `${Config.cdnUrl}/images/default-store.png`})`}}></div>
                <div className="brands-item-title">{getI18nText(item, 'district', language)}</div>
              </div>
            ))
          }
        </div>
      </Layout>
    )
  }
}

export default LocationListPage;
